(function() {
	"use strict";

	/**
	 * Extends Landbot widget for Flocert site
	 * Sets up custom variables and styles
	 *
	 * This should be loaded after the Landbot SDK is loaded
	 */
	function FlocertLandbot()
	{
		var global = {};

		var fn = {
			init: function()
			{
				var configUrlElem = jQuery('[data-landbot-config-url]');
				if (configUrlElem.length && configUrlElem.attr('data-landbot-config-url'))
				{
					var configUrl = configUrlElem.attr('data-landbot-config-url');
					global.landbot = new Landbot.Livechat({
						configUrl: configUrl,
					});
					window.myLandbot = global.landbot;
					global.landbot.onLoad(fn.onLandbotLoad);
				}
			},

			onLandbotLoad: function()
			{
				fn.setLoggedInVariable();
				fn.loadStyles();
			},

			/**
			 * @see https://davidwalsh.name/add-rules-stylesheets
			 */
			createStyleSheet: function(root)
			{
				// Create the <style> tag
				var style = root.createElement("style");

				// WebKit hack :(
				style.appendChild(root.createTextNode(""));

				// Add the <style> element to the page
				root.head.appendChild(style);

				return style.sheet;
			},

			/**
			 * @see https://davidwalsh.name/add-rules-stylesheets
			 */
			addCSSRule: function(sheet, selector, rules, index)
			{
				if ('insertRule' in sheet)
				{
					sheet.insertRule(selector + "{" + rules + "}", index);
				}
				else if ('addRule' in sheet)
				{
					sheet.addRule(selector, rules, index);
				}
			},

			setLoggedInVariable: function()
			{
				var isStakeholder = (document.cookie.indexOf('portal_access=') !== -1);
				global.landbot.setCustomData({
					'logged_in_stakeholder': isStakeholder,
				});
			},

			loadStyles: function()
			{
				var stylesheet = fn.createStyleSheet(global.landbot.document);
				fn.displaySidebar(stylesheet)
			},

			displaySidebar: function(stylesheet)
			{
				var scrollbarWidth = fn.getScrollbarWidth();
				fn.addCSSRule(stylesheet, '.Chat', 'overflow-y: scroll');
				fn.addCSSRule(stylesheet, '.Chat', 'position: relative');
				fn.addCSSRule(stylesheet, '.Chat', 'height: 100%');
				if (scrollbarWidth > 0) {
					fn.addCSSRule(stylesheet, '.Header--hasPersistentMenu', 'width: calc(100% - ' + scrollbarWidth + 'px);');
				}

				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'content: "Hi! How can I help you?"');
				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'position: absolute');
				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'opacity: 0');
				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'padding: 6px');
				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'color: #FFF');
				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'border-radius: 50px');
				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'z-index: 2');
				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'left: -71px');
				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'width: 101px');
				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'background: #00B9E4');
				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'border: 1.6px solid white');
				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'margin-left: -8px');
				fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'margin-top: 10px');

				fn.addCSSRule(stylesheet, '.image.is-launcher__avatar', 'width: 128px');
				fn.addCSSRule(stylesheet, '.image.is-launcher__avatar', 'height: 128px');

				fn.addCSSRule(stylesheet, '.LivechatLauncher', 'bottom: 4px');
				fn.addCSSRule(stylesheet, '.LivechatLauncher', 'padding: 0px !important');

				window.setTimeout(function() {
					fn.addCSSRule(stylesheet, '.LivechatLauncher:before', 'opacity: 1 !important');
				}, 3000);
			},

			/**
			 * @see https://davidwalsh.name/detect-scrollbar-width
			 */
			getScrollbarWidth: function()
			{
				// Create the measurement node
				var scrollDiv = document.createElement("div");
				scrollDiv.className = "scrollbar-measure";
				scrollDiv.style.width = '100px';
				scrollDiv.style.height = '100px';
				scrollDiv.style.overflow = 'scroll';
				scrollDiv.style.position = 'absolute';
				scrollDiv.style.top = '-9999px';
				document.body.appendChild(scrollDiv);

				// Get the scrollbar width
				var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

				// Delete the DIV
				document.body.removeChild(scrollDiv);

				return scrollbarWidth;
			},
		}

		jQuery(fn.init);
	}

	new FlocertLandbot();
})();